var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._m(1),_c('div',{staticClass:"view-wrapper"},[(_vm.$store.state.loading)?_c('MiniLoader'):_vm._e(),_c('router-view')],1),_vm._m(2),_vm._m(3)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('CookieNotice')
},function (){var _vm=this,_c=_vm._self._c;return _c('Nav')
},function (){var _vm=this,_c=_vm._self._c;return _c('Sponsors')
},function (){var _vm=this,_c=_vm._self._c;return _c('Footer')
}]

export { render, staticRenderFns }